(function () {
  /* Conversion capture — stamps the Cookiebot marketing-consent snapshot plus
     TikTok click identifiers onto the cart, so they land on
     order.note_attributes for the server-side Conversions Hub (CAPI Worker).
     The consent read is identical to snippets/cookie-consent.liquid: Cookiebot
     is the single authoritative ad-consent source.

     Every resolved consent state is stamped — 'granted' or 'denied' — so a
     missing _ad_consent on an order means the capture never ran (blocked JS,
     buy-it-now bypass, non-web order), never "the shopper declined". The hub's
     coverage metric depends on that distinction. */
  var CONSENT_ATTR = '_ad_consent';
  var TTCLID_ATTR = 'ttclid';
  var TTP_ATTR = '_ttp';
  var TTCLID_STORAGE = 'cc_ttclid';
  var TTCLID_SET_AT = 'cc_ttclid_set_at';
  var LAST_SIG = 'cc_last_attrs';
  /* TikTok click-through attribution window. */
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;

  function safeGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function safeSet(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }
  function safeRemove(key) { try { localStorage.removeItem(key); } catch (e) {} }

  /* Order-status / checkout page — cart attributes are already locked onto the
     order there, so there is nothing to stamp. */
  if (window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.OrderStatus) {
    return;
  }

  /* Capture ttclid from the landing URL immediately (independent of consent)
     and persist it so it survives to the cart page; sweep once the TTL lapses.
     A swept id is also blanked on the cart by the next stamp — the attrs
     always carry the identifier keys, and an empty value deletes the cart
     attribute (merge semantics would otherwise keep the stale one forever). */
  var urlTtclid = new URLSearchParams(window.location.search).get('ttclid');
  if (urlTtclid) {
    safeSet(TTCLID_STORAGE, urlTtclid);
    safeSet(TTCLID_SET_AT, Date.now().toString());
  } else {
    var setAt = parseInt(safeGet(TTCLID_SET_AT), 10);
    if (setAt && (Date.now() - setAt) > TTL_MS) {
      safeRemove(TTCLID_STORAGE);
      safeRemove(TTCLID_SET_AT);
    }
  }

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var idx = parts[i].indexOf('=');
      if (idx > -1 && parts[i].slice(0, idx) === name) {
        return decodeURIComponent(parts[i].slice(idx + 1));
      }
    }
    return null;
  }

  /* Authoritative marketing-consent read — mirrors snippets/cookie-consent.liquid. */
  function hasMarketingConsent() {
    return !!(typeof Cookiebot !== 'undefined' && Cookiebot.consent && Cookiebot.consent.marketing);
  }

  /* The dedup signature includes the cart token: Shopify replaces the cart
     after every completed checkout, and the fresh cart starts attribute-less —
     a device-scoped signature would skip stamping every repeat purchase. */
  function currentSig(attrs) {
    return JSON.stringify(attrs) + '|' + (readCookie('cart') || '');
  }

  var inflight = false;
  var queued = false;

  function updateCart(attrs) {
    if (currentSig(attrs) === safeGet(LAST_SIG)) return; /* unchanged — skip a redundant write */
    if (inflight) { queued = true; return; }
    inflight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    })
      .then(function (res) {
        /* Only a 2xx counts as stamped; anything else leaves the signature
           unset so the next pageview / consent event retries. Recompute the
           signature after the response — this POST may have just created the
           cart (and its cookie). */
        if (res.ok) safeSet(LAST_SIG, currentSig(attrs));
      })
      .catch(function () {}) /* fail silent to the shopper; retry via unset signature */
      .then(function () {
        inflight = false;
        if (queued) { queued = false; stamp(); }
      });
  }

  function stamp() {
    var granted = hasMarketingConsent();
    var attrs = {};
    attrs[CONSENT_ATTR] = granted ? 'granted' : 'denied';

    if (granted) {
      attrs[TTCLID_ATTR] = safeGet(TTCLID_STORAGE) || '';
      attrs[TTP_ATTR] = readCookie('_ttp') || '';
    } else {
      /* Denied (fresh or withdrawn) — strip identifiers everywhere so the
         order carries no ad ids without consent. */
      safeRemove(TTCLID_STORAGE);
      safeRemove(TTCLID_SET_AT);
      attrs[TTCLID_ATTR] = '';
      attrs[TTP_ATTR] = '';
    }

    updateCart(attrs);
  }

  /* Fires once consent is resolved — on every load and on fresh accept/decline —
     so the cart is re-stamped whenever marketing consent changes. This script
     is deferred, so for returning visitors Cookiebot may have resolved stored
     consent before the listener exists; hasResponse catches that case without
     ever stamping an unresolved state. */
  window.addEventListener('CookiebotOnConsentReady', stamp);
  if (window.Cookiebot && Cookiebot.hasResponse) stamp();
})();
